export default __webpack_public_path__ + "static/media/Img0016.38c67cb7.png";